import React from "react";
import Homepage from "./Homepage";
import HomepageV2 from "./v2/Homepage";
import { useIsNewLayout } from "../../services/SettingsContext";

// The version setting selects the homepage rendered at the canonical /web URL.
export default function HomepageSwitcher() {
  return useIsNewLayout() ? <HomepageV2 /> : <Homepage />;
}
